import type { SelectOptions } from '@hypercodestudio/basler-components/dist/components/modules/ProductVariantPickerSelect.vue';

export function createEmptyOption(
  label: string,
  selected = false
): SelectOptions {
  return {
    value: '',
    labelInfo: '',
    label,
    selected
  } as SelectOptions;
}
